<!--
 * @FileDescription: 退款成功页面-Web
 * @Author: 陈文景
 * @Date: 2022-11-07 18:28:30
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="container">
    <div style="margin-top: 8px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fontfine" :to="{ path: '/order/list' }">{{ $t('Order.Refund.Success.Web.Index.MyOrder') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('Order.Refund.Success.Web.Index.RufundOrder') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <h3 class="rufund">{{ $t('Order.Refund.Success.Web.Index.RufundOrder') }}</h3>

    <div v-loading="loading" class="success">
      <div class="tips">
        <span class="see-all-order" @click="goToAllOrderList">
          <span>{{ $t('Order.Refund.Success.Web.Index.AllOrders') }}</span>
          <i class="el-icon-arrow-right" />
        </span>
        <div class="content">
          <span class="icon">
            <i class="el-icon-success" />
          </span>
          <h3 class="title">{{ $t('Order.Refund.Success.Web.Index.SubmittedSuccessfully') }}</h3>
          <div class="subheading">{{ $t('Order.Refund.Success.Web.Index.WaitingForReview') }}</div>
          <div class="button-group">
            <el-button class="back" @click="goBack">{{ $t('Order.Refund.Success.Web.Index.Back') }}</el-button>
            <el-button type="primary" class="check" @click="goToAfterSalesOrderList">{{ $t('Order.Refund.Success.Web.Index.CheckAfterSales') }}</el-button>
          </div>
        </div>
      </div>

      <div class="details">
        <div class="list">
          <template v-if="details.packItems && details.packItems.length">
            <div v-for="pack in details.packItems" :key="pack.omsPackId">
              <div class="header">
                <h3>{{ $t('Order.Refund.Success.Web.Index.RufundInformation') }}</h3>
                <div class="order-info">
                  <span class="order-code">{{ $t('Order.Refund.Success.Web.Index.OrderID') }}: {{ defaultTips(pack.kkOrderId) }}</span>
                  <span class="tracking-code">{{ $t('Order.Refund.Success.Web.Index.TrackingCode') }}: {{ defaultTips(pack.omsPackId) }}</span>
                  <span class="order-time">{{ $t('Order.Refund.Success.Web.Index.PaymentTime') }}: {{ defaultTips(formatTimeStamp(pack.payDate)) }}</span>
                </div>
              </div>
              <div>
                <SkuInfoItemTwo v-for="item in pack.items" :key="item.skuCode" :data="item" />
              </div>
            </div>
          </template>

          <template v-else>
            <div class="not-data">
              <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
              <div class="tips-text">{{ $t('Order.Refund.Success.Web.Index.NoRecord') }}</div>
            </div>
          </template>
        </div>

        <div class="info">
          <div class="top">
            <div class="amount-info">
              <h3 class="title">{{ $t('Order.Refund.Success.Web.Index.RefundedAmount') }}</h3>
              <p>
                <span>{{ $t('Order.Refund.Success.Web.Index.ItemSubtotal') }}</span>
                <span class="money">{{ `US $${amountTips(details.skusAmount)}` }}</span>
              </p>
              <p>
                <span>{{ $t('Order.Refund.Success.Web.Index.ShippingSubtotal') }}</span>
                <span class="money">{{ `US $${amountTips(details.freightAmount)}` }}</span>
              </p>
              <p>
                <!-- <span>{{ $t('Order.Refund.Success.Web.Index.Promotion') }}</span> -->
                <span>Promo code</span>
                <span class="money">{{ `- US $${amountTips(details.promotionAmount)}` }}</span>
              </p>
              <p>
                <span>Coupon</span>
                <span class="money">{{ `- US $${amountTips(details.couponTicketAmount)}` }}</span>
              </p>
            </div>
            <div class="refund-info">
              <span>{{ $t('Order.Refund.Success.Web.Index.Total') }}</span>
              <span>{{ `- US $${amountTips(details.totalAmount)}` }}</span>
            </div>
          </div>
          <div class="button">
            <h3 class="title">{{ $t('Order.Refund.Success.Web.Index.ShippingAddress') }}</h3>
            <div class="info">
              <p>{{ details?.address?.recipient }} {{ details?.address?.phone }}</p>
              <p>{{ details?.address?.street1 }}</p>
              <p v-if="details?.address?.street2">
                {{ details?.address?.street2 }}
              </p>
              <p>{{ details?.address?.city }} {{ details?.address?.province }} {{ details?.address?.country }} {{ details?.address?.zip }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { formatTimeStamp } from '@/util/moment'
import SkuInfoItemTwo from './components/SkuInfoItemTwo.vue'

export default {
  components: {
    SkuInfoItemTwo
  },
  data() {
    return {
      formatTimeStamp,

      loading: false,

      details: {} // 详情
    }
  },
  computed: {
    amountTips() {
      return (value) => value || 0
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  created() {
    this.getAfterSalesOrderDetails()
  },
  methods: {
    /**
     * API 获取售后订单详情
     */
    async getAfterSalesOrderDetails() {
      try {
        this.loading = true
        let { data } = await API.getAfterSalesOrderDetails(this.$route.query.returnsId)
        data.packItems = this.reformData(data.packItems || [])
        this.details = data
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 改造未发货列表数据
     *
     * @param {Array} data 原数据
     * @returns {Array} 改造后的数据
     */
    reformData(data) {
      if (data.length) {
        data.forEach((outside) => {
          if (outside && outside.items && outside.items.length) {
            outside.items = outside.items.map((item) => ({
              ...item,
              options:
                JSON.parse(item.options) &&
                JSON.parse(item.options)
                  .map((option) => JSON.parse(option).value)
                  .join('、')
            }))
          }
        })
      }
      return data
    },

    /**
     * 跳转到所有订单列表页面
     */
    goToAllOrderList() {
      this.$router.push('/order/list')
    },

    /**
     * 返回按钮的回调事件
     */
    goBack() {
      this.$router.go(-1)
    },

    /**
     * 跳转到售后订单列表页面
     */
    goToAfterSalesOrderList() {
      this.$router.push('/order/sales')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1192px;
  margin: 0 auto;

  .fontfine {
    /deep/span {
      font-weight: normal;
    }
  }

  .rufund {
    font-size: 18px;
    font-weight: 500;
    margin: 8px 0;
  }

  .success {
    .tips {
      position: relative;
      background-color: #fff;
      .see-all-order {
        position: absolute;
        top: 40px;
        right: 32px;
        color: #10141d;
        font-size: 16px;
        height: 20px;
        line-height: 20px;
        text-align: end;
        user-select: none;
        cursor: pointer;
        i {
          color: #10141d !important;
        }
        &:hover {
          color: #99c41c;
          i {
            color: #99c41c !important;
          }
        }
      }
      .content {
        height: 100%;
        text-align: center;
        padding-top: 70px;
        .icon {
          color: #99c41c;
          font-size: 70px;
        }
        .title {
          font-size: 24px;
          margin: 18px 0;
        }
        .subheading {
          font-size: 18px;
          margin-bottom: 45px;
        }
        .button-group {
          padding-bottom: 25px;
          .back {
            color: #10141d;
            width: 156px;
            height: 45px;
            font-size: 16px;
          }
          .check {
            width: 216px;
            height: 45px;
            font-size: 16px;
            margin-left: 25px;
          }
        }
      }
    }
    .details {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .list {
        width: 830px;
        padding: 15px 20px;
        background-color: #fff;
        .header {
          h3 {
            font-size: 18px;
            font-weight: 500;
          }
          .order-info {
            display: flex;
            color: #747a87;
            font-size: 14px;
            margin: 12px 0 18px;
            justify-content: space-between;
            .tracking-code {
              color: #99c41c;
            }
          }
        }
        .not-data {
          height: 100%;
          text-align: center;
          .tips-text {
            color: #747a87;
            margin-top: 28px;
          }
        }
      }
      .info {
        width: 352px;
        .top {
          width: 100%;
          .amount-info {
            // height: 215px;
            padding: 22px;
            background-color: #fff;
            border-bottom: 1px solid #f5f7f7;
            .title {
              font-size: 18px;
              font-weight: 500;
            }
            p {
              display: flex;
              color: #747a87;
              font-size: 14px;
              font-weight: 500;
              margin-top: 20px;
              justify-content: space-between;
              .money {
                color: #10141d;
                font-size: 16px;
                font-weight: 500;
              }
            }
          }
          .refund-info {
            display: flex;
            color: #000;
            font-size: 18px;
            font-weight: 500;
            padding: 22px 12px;
            align-items: center;
            background-color: #fff;
            justify-content: space-between;
          }
        }
        .button {
          width: 100%;
          margin-top: 10px;
          padding: 12px;
          background-color: #fff;
          .title {
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 8px;
          }
          .info {
            width: 100%;
            color: #8b93a3;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
